import { render } from "./MagazzinoPage.vue?vue&type=template&id=0e5bc754&scoped=true"
import script from "./MagazzinoPage.vue?vue&type=script&lang=js"
export * from "./MagazzinoPage.vue?vue&type=script&lang=js"

import "@/css/StockPage.css?vue&type=style&index=0&lang=css&external"
import "./MagazzinoPage.vue?vue&type=style&index=1&id=0e5bc754&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5bc754"]])

export default __exports__